if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      color_anterior = null;
      color_anterior_complete = null;

      colorAnterior = null; // Track last selected color
      sizeAnterior = null; // Track last selected size

      productsInfo = [
	{
		SKU: "OS-BG",
		variantId: 45746641797275,
    productId: "8320961740955",
		product: "OVER SHIRT",
		productUrl: "https://masloe.com/products/over-shirt?variant=45746641797275",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
		color: "STONE",
		price: 135,
	},
	{
		SKU: "OS-FG",
		variantId: 45746641928347,
    productId: "8320961740955",
		product: "OVER SHIRT",
		productUrl: "https://masloe.com/products/over-shirt?variant=45746641928347",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-014_1.png?v=1731100717",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/silver_gray_over_shirt.jpg?v=1732411335",
		color: "SILVER",
		price: 135,
	},
	{
		SKU: "OS-PG",
		variantId: 45746642059419,
    productId: "8320961740955",
		product: "OVER SHIRT",
		productUrl: "https://masloe.com/products/over-shirt?variant=45746642059419",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-013_1.png?v=1731100734",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pastel_gray_over_shirt.jpg?v=1732411335",
		color: "PASTEL GRAY",
		price: 135,
	},
	{
		SKU: "TR-DN",
		variantId: 45746683478171,
    productId: "8320969900187",
		product: "SLIM FIT TROUSERS",
		productUrl: "https://masloe.com/products/trouser?variant=45746683478171",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
		color: "NAVY",
		price: 128,
	},
	{
		SKU: "TR-BG",
		variantId: 45746683609243,
    productId: "8320969900187",
		product: "SLIM FIT TROUSERS",
		productUrl: "https://masloe.com/products/trouser?variant=45746683609243",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-011_1.png?v=1731100983",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ash_gray_trouser.jpg?v=1732411350",
		color: "ASH GRAY",
		price: 128,
	},
	{
		SKU: "TR-CH",
		variantId: 45746683740315,
    productId: "8320969900187",
		product: "SLIM FIT TROUSERS",
		productUrl: "https://masloe.com/products/trouser?variant=45746683740315",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
		color: "CHARCOAL",
		price: 128,
	},
	{
		SKU: "SW-SD",
		variantId: 45746717065371,
    productId: "8320972980379",
		product: "388 CREWNECK",
		productUrl: "https://masloe.com/products/388-crewneck?variant=45746717065371",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-009_1.png?v=1731101351",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_crewn.jpg?v=1732411321",
		color: "CREAM",
		price: 105,
	},
	{
		SKU: "SW-HB",
		variantId: 45746717196443,
    productId: "8320972980379",
		product: "388 CREWNECK",
		productUrl: "https://masloe.com/products/388-crewneck?variant=45746717196443",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-004_1.png?v=1731101366",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_crewn.jpg?v=1732411321",
		color: "OAT",
		price: 105,
	},
	{
		SKU: "SW-ON",
		variantId: 45746717327515,
    productId: "8320972980379",
		product: "388 CREWNECK",
		productUrl: "https://masloe.com/products/388-crewneck?variant=45746717327515",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-008_1.png?v=1731101378",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_crew_n.jpg?v=1732411321",
		color: "NAVY",
		price: 105,
	},
	{
		SKU: "HD-SD",
		variantId: 45746698682523,
    productId: "8320972882075",
		product: "388 HOODIE",
		productUrl: "https://masloe.com/products/388-hoodie?variant=45746698682523",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-015_1.png?v=1731101137",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_hoodie.jpg?v=1732411327",
		color: "CREAM",
		price: 120,
	},
	{
		SKU: "HD-HB",
		variantId: 45746698813595,
    productId: "8320972882075",
		product: "388 HOODIE",
		productUrl: "https://masloe.com/products/388-hoodie?variant=45746698813595",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
		color: "OAT",
		price: 120,
	},
	{
		SKU: "HD-ON",
		variantId: 45848967315611,
    productId: "8320972882075",
		product: "388 HOODIE",
		productUrl: "https://masloe.com/products/388-hoodie?variant=45848967315611",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-006_1.png?v=1731101177",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_hoodie.jpg?v=1732411327",
		color: "NAVY",
		price: 120,
	},
	{
		SKU: "TS-IV",
		variantId: 45745683497115,
    productId: "8320625672347",
		product: "T SHIRT",
		productUrl: "https://masloe.com/products/t-shirt?variant=45745683497115",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-002_2.png?v=1731091835",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
		color: "IVORY",
		price: 50,
	},
	{
		SKU: "TS-GR",
		variantId: 45745683464347,
    productId: "8320625672347",
		product: "T SHIRT",
		productUrl: "https://masloe.com/products/t-shirt?variant=45745683464347",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MASS-001_1.png?v=1731091758",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pale_gray_t_shirt.jpg?v=1732411342",
		color: "PASTEL GRAY",
		price: 50,
	},
	{
		SKU: "TS-OW",
		variantId: 45745683529883,
    productId: "8320625672347",
		product: "T SHIRT",
		productUrl: "https://masloe.com/products/t-shirt?variant=45745683529883",
		mainImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
		hoverImage: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
		color: "OFF WHITE",
		price: 50,
	},
];
      completeTheLook = [
  {
    "variantId": 45746641797275,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "STONE",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683478171,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683478171",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
    "color": "NAVY",
    "price": 128
  },
  {
    "variantId": 45746641797275,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "STONE",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717327515,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717327515",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-008_1.png?v=1731101378",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_crew_n.jpg?v=1732411321",
    "color": "NAVY",
    "price": 105
  },
  {
    "variantId": 45746641928347,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "SILVER",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45746641928347,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "SILVER",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717065371,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717065371",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-009_1.png?v=1731101351",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_crewn.jpg?v=1732411321",
    "color": "CREAM",
    "price": 105
  },
  {
    "variantId": 45746642059419,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45746642059419,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683529883,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683529883",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
    "color": "OFF WHITE",
    "price": 50
  },
  {
    "variantId": 45746683478171,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "NAVY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641797275,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641797275",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
    "color": "STONE",
    "price": 135
  },
  {
    "variantId": 45746683478171,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "NAVY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  },
  {
    "variantId": 45746683609243,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "ASH GRAY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  },
  {
    "variantId": 45746683609243,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "ASH GRAY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683464347,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683464347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MASS-001_1.png?v=1731091758",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pale_gray_t_shirt.jpg?v=1732411342",
    "color": "PASTEL GRAY",
    "price": 50
  },
  {
    "variantId": 45746683740315,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "CHARCOAL",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746642059419,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746642059419",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-013_1.png?v=1731100734",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pastel_gray_over_shirt.jpg?v=1732411335",
    "color": "PASTEL GRAY",
    "price": 135
  },
  {
    "variantId": 45746683740315,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "CHARCOAL",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717327515,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717327515",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-008_1.png?v=1731101378",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_crew_n.jpg?v=1732411321",
    "color": "NAVY",
    "price": 105
  },
  {
    "variantId": 45746717065371,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "CREAM",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683609243,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683609243",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-011_1.png?v=1731100983",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ash_gray_trouser.jpg?v=1732411350",
    "color": "ASH GRAY",
    "price": 128
  },
  {
    "variantId": 45746717065371,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "CREAM",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641928347,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641928347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-014_1.png?v=1731100717",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/silver_gray_over_shirt.jpg?v=1732411335",
    "color": "SILVER",
    "price": 135
  },
  {
    "variantId": 45746717196443,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "OAT",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683478171,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683478171",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
    "color": "NAVY",
    "price": 128
  },
  {
    "variantId": 45746717196443,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "OAT",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641797275,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641797275",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
    "color": "STONE",
    "price": 135
  },
  {
    "variantId": 45746717327515,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "NAVY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45746717327515,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "NAVY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641797275,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641797275",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
    "color": "STONE",
    "price": 135
  },
  {
    "variantId": 45746698682523,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "CREAM",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683529883,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683529883",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
    "color": "OFF WHITE",
    "price": 50
  },
  {
    "variantId": 45746698682523,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "CREAM",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717065371,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717065371",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-009_1.png?v=1731101351",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_crewn.jpg?v=1732411321",
    "color": "CREAM",
    "price": 105
  },
  {
    "variantId": 45746698813595,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "OAT",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683464347,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683464347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MASS-001_1.png?v=1731091758",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pale_gray_t_shirt.jpg?v=1732411342",
    "color": "PASTEL GRAY",
    "price": 50
  },
  {
    "variantId": 45746698813595,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "OAT",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717196443,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717196443",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-004_1.png?v=1731101366",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_crewn.jpg?v=1732411321",
    "color": "OAT",
    "price": 105
  },
  {
    "variantId": 45848967315611,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "NAVY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683497115,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683497115",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-002_1.png?v=1731091835",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "IVORY",
    "price": 50
  },
  {
    "variantId": 45848967315611,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "NAVY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641928347,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641928347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-014_1.png?v=1731100717",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/silver_gray_over_shirt.jpg?v=1732411335",
    "color": "SILVER",
    "price": 135
  },
  {
    "variantId": 45745683497115,
    "mainProductName": "T SHIRT",
    "mainProductColor": "IVORY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683609243,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683609243",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-011_1.png?v=1731100983",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ash_gray_trouser.jpg?v=1732411350",
    "color": "ASH GRAY",
    "price": 128
  },
  {
    "variantId": 45745683497115,
    "mainProductName": "T SHIRT",
    "mainProductColor": "IVORY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683529883,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683529883",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
    "color": "OFF WHITE",
    "price": 50
  },
  {
    "variantId": 45745683464347,
    "mainProductName": "T SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683478171,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683478171",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
    "color": "NAVY",
    "price": 128
  },
  {
    "variantId": 45745683464347,
    "mainProductName": "T SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717065371,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717065371",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-009_1.png?v=1731101351",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_crewn.jpg?v=1732411321",
    "color": "CREAM",
    "price": 105
  },
  {
    "variantId": 45745683529883,
    "mainProductName": "T SHIRT",
    "mainProductColor": "OFF WHITE",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45745683529883,
    "mainProductName": "T SHIRT",
    "mainProductColor": "OFF WHITE",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  }
];
      upgrade_relationships = [
  {
    "variantId": 45746641797275,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "STONE",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45746641797275,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "STONE",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641928347,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641928347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-014_1.png?v=1731100717",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/silver_gray_over_shirt.jpg?v=1732411335",
    "color": "SILVER",
    "price": 135
  },
  {
    "variantId": 45746641797275,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "STONE",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683529883,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683529883",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
    "color": "OFF WHITE",
    "price": 50
  },
  {
    "variantId": 45746641797275,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "STONE",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698682523,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698682523",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-015_1.png?v=1731101137",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_hoodie.jpg?v=1732411327",
    "color": "CREAM",
    "price": 120
  },
  {
    "variantId": 45746641928347,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "SILVER",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683478171,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683478171",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
    "color": "NAVY",
    "price": 128
  },
  {
    "variantId": 45746641928347,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "SILVER",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746642059419,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746642059419",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-013_1.png?v=1731100734",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pastel_gray_over_shirt.jpg?v=1732411335",
    "color": "PASTEL GRAY",
    "price": 135
  },
  {
    "variantId": 45746641928347,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "SILVER",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683497115,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683497115",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-002_1.png?v=1731091835",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "IVORY",
    "price": 50
  },
  {
    "variantId": 45746641928347,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "SILVER",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  },
  {
    "variantId": 45746642059419,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683609243,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683609243",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-011_1.png?v=1731100983",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ash_gray_trouser.jpg?v=1732411350",
    "color": "ASH GRAY",
    "price": 128
  },
  {
    "variantId": 45746642059419,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641797275,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641797275",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
    "color": "STONE",
    "price": 135
  },
  {
    "variantId": 45746642059419,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683464347,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683464347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MASS-001_1.png?v=1731091758",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "PASTEL GRAY",
    "price": 50
  },
  {
    "variantId": 45746642059419,
    "mainProductName": "OVER SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45848967315611,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45848967315611",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-006_1.png?v=1731101177",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_hoodie.jpg?v=1732411327",
    "color": "NAVY",
    "price": 120
  },
  {
    "variantId": 45746683478171,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "NAVY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641928347,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641928347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-014_1.png?v=1731100717",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/silver_gray_over_shirt.jpg?v=1732411335",
    "color": "SILVER",
    "price": 135
  },
  {
    "variantId": 45746683478171,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "NAVY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45746683478171,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "NAVY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683529883,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683529883",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
    "color": "OFF WHITE",
    "price": 50
  },
  {
    "variantId": 45746683478171,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "NAVY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698682523,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698682523",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-015_1.png?v=1731101137",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_hoodie.jpg?v=1732411327",
    "color": "CREAM",
    "price": 120
  },
  {
    "variantId": 45746683609243,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "ASH GRAY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746642059419,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746642059419",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-013_1.png?v=1731100734",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pastel_gray_over_shirt.jpg?v=1732411335",
    "color": "PASTEL GRAY",
    "price": 135
  },
  {
    "variantId": 45746683609243,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "ASH GRAY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683478171,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683478171",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
    "color": "NAVY",
    "price": 128
  },
  {
    "variantId": 45746683609243,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "ASH GRAY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683497115,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683497115",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-002_1.png?v=1731091835",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "IVORY",
    "price": 50
  },
  {
    "variantId": 45746683609243,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "ASH GRAY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45848967315611,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45848967315611",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-006_1.png?v=1731101177",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_hoodie.jpg?v=1732411327",
    "color": "NAVY",
    "price": 120
  },
  {
    "variantId": 45746683740315,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "CHARCOAL",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641797275,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641797275",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
    "color": "STONE",
    "price": 135
  },
  {
    "variantId": 45746683740315,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "CHARCOAL",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683609243,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683609243",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-011_1.png?v=1731100983",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ash_gray_trouser.jpg?v=1732411350",
    "color": "ASH GRAY",
    "price": 128
  },
  {
    "variantId": 45746683740315,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "CHARCOAL",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683464347,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683464347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MASS-001_1.png?v=1731091758",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "PASTEL GRAY",
    "price": 50
  },
  {
    "variantId": 45746683740315,
    "mainProductName": "SLIM FIT TROUSERS",
    "mainProductColor": "CHARCOAL",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  },
  {
    "variantId": 45746717065371,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "CREAM",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683529883,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683529883",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
    "color": "OFF WHITE",
    "price": 50
  },
  {
    "variantId": 45746717065371,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "CREAM",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717196443,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717196443",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-004_1.png?v=1731101366",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_crewn.jpg?v=1732411321",
    "color": "OAT",
    "price": 105
  },
  {
    "variantId": 45746717065371,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "CREAM",
    "variantProductId": "8320972882075",
    "variantVariantId": 45848967315611,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45848967315611",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-006_1.png?v=1731101177",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_hoodie.jpg?v=1732411327",
    "color": "NAVY",
    "price": 120
  },
  {
    "variantId": 45746717065371,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "CREAM",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683478171,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683478171",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
    "color": "NAVY",
    "price": 128
  },
  {
    "variantId": 45746717196443,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "OAT",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683497115,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683497115",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-002_1.png?v=1731091835",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "IVORY",
    "price": 50
  },
  {
    "variantId": 45746717196443,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "OAT",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717327515,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717327515",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-008_1.png?v=1731101378",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_crew_n.jpg?v=1732411321",
    "color": "NAVY",
    "price": 105
  },
  {
    "variantId": 45746717196443,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "OAT",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698682523,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698682523",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-015_1.png?v=1731101137",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_hoodie.jpg?v=1732411327",
    "color": "CREAM",
    "price": 120
  },
  {
    "variantId": 45746717196443,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "OAT",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45746717327515,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "NAVY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683464347,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683464347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MASS-001_1.png?v=1731091758",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "PASTEL GRAY",
    "price": 50
  },
  {
    "variantId": 45746717327515,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "NAVY",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717065371,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717065371",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-009_1.png?v=1731101351",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_crewn.jpg?v=1732411321",
    "color": "CREAM",
    "price": 105
  },
  {
    "variantId": 45746717327515,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "NAVY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  },
  {
    "variantId": 45746717327515,
    "mainProductName": "388 CREWNECK",
    "mainProductColor": "NAVY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683609243,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683609243",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-011_1.png?v=1731100983",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ash_gray_trouser.jpg?v=1732411350",
    "color": "ASH GRAY",
    "price": 128
  },
  {
    "variantId": 45746698682523,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "CREAM",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641928347,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641928347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-014_1.png?v=1731100717",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/silver_gray_over_shirt.jpg?v=1732411335",
    "color": "SILVER",
    "price": 135
  },
  {
    "variantId": 45746698682523,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "CREAM",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  },
  {
    "variantId": 45746698682523,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "CREAM",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717327515,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717327515",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-008_1.png?v=1731101378",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_crew_n.jpg?v=1732411321",
    "color": "NAVY",
    "price": 105
  },
  {
    "variantId": 45746698682523,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "CREAM",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683609243,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683609243",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-011_1.png?v=1731100983",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ash_gray_trouser.jpg?v=1732411350",
    "color": "ASH GRAY",
    "price": 128
  },
  {
    "variantId": 45746698813595,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "OAT",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746642059419,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746642059419",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-013_1.png?v=1731100734",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pastel_gray_over_shirt.jpg?v=1732411335",
    "color": "PASTEL GRAY",
    "price": 135
  },
  {
    "variantId": 45746698813595,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "OAT",
    "variantProductId": "8320972882075",
    "variantVariantId": 45848967315611,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45848967315611",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-006_1.png?v=1731101177",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_hoodie.jpg?v=1732411327",
    "color": "NAVY",
    "price": 120
  },
  {
    "variantId": 45746698813595,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "OAT",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717065371,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717065371",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-009_1.png?v=1731101351",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_crewn.jpg?v=1732411321",
    "color": "CREAM",
    "price": 105
  },
  {
    "variantId": 45746698813595,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "OAT",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683478171,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683478171",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-012_1.png?v=1731100964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_trousers.jpg?v=1732411350",
    "color": "NAVY",
    "price": 128
  },
  {
    "variantId": 45848967315611,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "NAVY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641797275,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641797275",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
    "color": "STONE",
    "price": 135
  },
  {
    "variantId": 45848967315611,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "NAVY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698682523,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698682523",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-015_1.png?v=1731101137",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_hoodie.jpg?v=1732411327",
    "color": "CREAM",
    "price": 120
  },
  {
    "variantId": 45848967315611,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "NAVY",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717196443,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717196443",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-004_1.png?v=1731101366",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_crewn.jpg?v=1732411321",
    "color": "OAT",
    "price": 105
  },
  {
    "variantId": 45848967315611,
    "mainProductName": "388 HOODIE",
    "mainProductColor": "NAVY",
    "variantProductId": "8320969900187",
    "variantVariantId": 45746683740315,
    "productName": "SLIM FIT TROUSERS",
    "product": "https://masloe.com/products/trouser?variant=45746683740315",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-003_1.png?v=1731101023",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/charcoal_trouser.jpg?v=1732411350",
    "color": "CHARCOAL",
    "price": 128
  },
  {
    "variantId": 45745683497115,
    "mainProductName": "T SHIRT",
    "mainProductColor": "IVORY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698813595,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698813595",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-010_1.png?v=1743808306",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_hoodie.jpg?v=1732411327",
    "color": "OAT",
    "price": 120
  },
  {
    "variantId": 45745683497115,
    "mainProductName": "T SHIRT",
    "mainProductColor": "IVORY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683464347,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683464347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MASS-001_1.png?v=1731091758",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "PASTEL GRAY",
    "price": 50
  },
  {
    "variantId": 45745683497115,
    "mainProductName": "T SHIRT",
    "mainProductColor": "IVORY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641797275,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641797275",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-005_1.png?v=1731100688",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/stone_over_shirt.jpg?v=1732411335",
    "color": "STONE",
    "price": 135
  },
  {
    "variantId": 45745683497115,
    "mainProductName": "T SHIRT",
    "mainProductColor": "IVORY",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717065371,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717065371",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-009_1.png?v=1731101351",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_crewn.jpg?v=1732411321",
    "color": "CREAM",
    "price": 105
  },
  {
    "variantId": 45745683464347,
    "mainProductName": "T SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320972882075",
    "variantVariantId": 45848967315611,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45848967315611",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-006_1.png?v=1731101177",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_hoodie.jpg?v=1732411327",
    "color": "NAVY",
    "price": 120
  },
  {
    "variantId": 45745683464347,
    "mainProductName": "T SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683529883,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683529883",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-007_1.png?v=1731091964",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/off_white_t_shirt.jpg?v=1732411342",
    "color": "OFF WHITE",
    "price": 50
  },
  {
    "variantId": 45745683464347,
    "mainProductName": "T SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746641928347,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746641928347",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-014_1.png?v=1731100717",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/silver_gray_over_shirt.jpg?v=1732411335",
    "color": "SILVER",
    "price": 135
  },
  {
    "variantId": 45745683464347,
    "mainProductName": "T SHIRT",
    "mainProductColor": "PASTEL GRAY",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717196443,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717196443",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-004_1.png?v=1731101366",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/oat_crewn.jpg?v=1732411321",
    "color": "OAT",
    "price": 105
  },
  {
    "variantId": 45745683529883,
    "mainProductName": "T SHIRT",
    "mainProductColor": "OFF WHITE",
    "variantProductId": "8320972882075",
    "variantVariantId": 45746698682523,
    "productName": "388 HOODIE",
    "product": "https://masloe.com/products/388-hoodie?variant=45746698682523",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-015_1.png?v=1731101137",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/cream_hoodie.jpg?v=1732411327",
    "color": "CREAM",
    "price": 120
  },
  {
    "variantId": 45745683529883,
    "mainProductName": "T SHIRT",
    "mainProductColor": "OFF WHITE",
    "variantProductId": "8320625672347",
    "variantVariantId": 45745683497115,
    "productName": "T SHIRT",
    "product": "https://masloe.com/products/t-shirt?variant=45745683497115",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-002_1.png?v=1731091835",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/ivory_tshirt.jpg?v=1732411342",
    "color": "IVORY",
    "price": 50
  },
  {
    "variantId": 45745683529883,
    "mainProductName": "T SHIRT",
    "mainProductColor": "OFF WHITE",
    "variantProductId": "8320961740955",
    "variantVariantId": 45746642059419,
    "productName": "OVER SHIRT",
    "product": "https://masloe.com/products/over-shirt?variant=45746642059419",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-013_1.png?v=1731100734",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/pastel_gray_over_shirt.jpg?v=1732411335",
    "color": "PASTEL GRAY",
    "price": 135
  },
  {
    "variantId": 45745683529883,
    "mainProductName": "T SHIRT",
    "mainProductColor": "OFF WHITE",
    "variantProductId": "8320972980379",
    "variantVariantId": 45746717327515,
    "productName": "388 CREWNECK",
    "product": "https://masloe.com/products/388-crewneck?variant=45746717327515",
    "image": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/MAS-008_1.png?v=1731101378",
    "hoverImage": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/navy_crew_n.jpg?v=1732411321",
    "color": "NAVY",
    "price": 105
  }
];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        // Asegúrate de que el QuickAddModal está presente
        if (!document.querySelector('quick-add-modal')) {
            const modalContainer = document.createElement('quick-add-modal');
            document.body.appendChild(modalContainer);
        }

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        // Inicializa la galería de imágenes con el color seleccionado por defecto
        this.updateGallery();
        this.updateRecommendation();
        this.updateCompleteLook();

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }
      
      updateGallery() {
        
          // Verificar si hay un quick-add-modal con atributo open
          const quickAddModal = document.querySelector('quick-add-modal[open]');
          const searchScope = quickAddModal || document; // Usar el modal si está abierto, sino el documento
      
          // Obtener el valor de la variante seleccionada
          const variantElement = searchScope.querySelector(".custom_color_form__label span");
          if (!variantElement) {
              console.warn("No se encontró el elemento de variante seleccionada.");
              return;
          }
          
          const selectedVariant = variantElement.textContent.trim().toLowerCase();
         // console.log('selectedVariant gallery', selectedVariant);
      
        //setTimeout(()=>{
          escondeElementosImagen();
          muestraElementosImagen();
        //}, 1500);
      
          function escondeElementosImagen() {
              searchScope.querySelectorAll('li.product__media-item, li.product__media-list').forEach(item => {
                  item.classList.add('hidden');
              });
          }
      
          function muestraElementosImagen() {
              searchScope.querySelectorAll('li.product__media-item, li.product__media-list').forEach(item => {
                  const img = item.querySelector('img'); // Buscar la imagen dentro del <li>
                  if (img && img.getAttribute('alt')?.trim().toLowerCase() === selectedVariant) {
                      item.classList.remove('hidden');
                  }
              });
          }
      }

      updateRecommendation() {
        const selectedProductName = document.querySelector('.product-title h1').textContent.trim().toUpperCase();
        const selectedColor = document.querySelector('.custom_color_form__label span').textContent.trim().toUpperCase();
        const recommendationsGallery = document.querySelector('.recommendations-gallery');
        const selectedIdVariant = document.querySelector('.product-variant-id').value;
        let sRecommendations = "";
        
        this.upgrade_relationships.forEach((item) => {
          if (item.mainProductName.toUpperCase() === selectedProductName && item.mainProductColor.toUpperCase() === selectedColor) {
            // Divide item.productName en palabras
            const productNameWords = item.productName.split(' ');
            let productNameHTML = '';
            productNameWords.forEach((word) => {
              productNameHTML += `<p>${word}</p>`;
            });
        
            // Agrega el HTML generado al contenedor
            sRecommendations += `
              <div class="recommendation-item">
                <a href="${item.product}" class="full-unstyled-link">
                  <div class="variant-image-wrapper">
                      <img
                          src="${item.image}"
                          alt="Imagen para ${selectedIdVariant}"
                          class="variant-image primary-image"
                          loading="lazy"
                      >
                      <img
                          src="${item.hoverImage}"
                          alt="Hover para ${selectedIdVariant}"
                          class="variant-image hover-image"
                          loading="lazy"
                      >
                  </div>
                  <div class="variant-container">
                      <div class="variant-color">${productNameHTML}</div>
                      <p class="variant-stock">[${item.price}]</p>
                  </div>
                </a>
              </div>
            `;
          }
        });

    
        recommendationsGallery.innerHTML = sRecommendations;
      }

      updateCompleteLook() {
          const selectedProductName = document.querySelector('.product-title h1').textContent.trim().toUpperCase();
          const selectedColor = document.querySelector('.custom_color_form__label span').textContent.trim().toUpperCase();
          const selectedIdVariant = document.querySelector('.product-variant-id').value;
          let sCompleteLook = "";
          const completeLookGallery = document.querySelector('.recommendation-list');
      
          this.completeTheLook.forEach((item) => {
            //console.log(item.mainProductName.toUpperCase() , selectedProductName , item.mainProductColor.toUpperCase() , selectedColor);
              if (item.mainProductName.toUpperCase() === selectedProductName && item.mainProductColor.toUpperCase() === selectedColor) {
                  sCompleteLook += `
                  <div class="recommendation-card">
                      <a href="${item.product}" class="recommendation-link">
                          <img
                              src="${item.image}"
                              alt="Complete the look ${selectedIdVariant}"
                              class="recommendation-image"
                          />
                      </a>
                      <div class="card-details">
                          <div class="card-details-info">
                              <p class="card-title">${item.productName}</p>
                              <p class="card-price">$${item.price.toFixed(0)}</p>
                          </div>
                          <div class="card-buttons">
                            
                                <div class="custom-quick-add">
                                    <button
                                      id="submit-${item.variantId}"
                                      type="submit"
                                      name="add"
                                      class="quick-add__submit size-selector-button card--horizontal__quick-add animate-arrow"
                                      aria-haspopup="dialog"
                                      data-product-url="${item.product}"
                                      data-product-variantId="${selectedIdVariant}"
                                    >
                                      <div class="custom_choose_option">
                                        SELECT A SIZE
                                      </div>
                                      <div class="loading-spinner loading__spinner hidden">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                                      </div>
                                    </button>
                                </div>
                              
                              `;

                              
                                      
                         sCompleteLook += `</div>
                      </div>
                  </div>`;

              }
          });

        if(!document.querySelector(`#QuickAdd-${selectedIdVariant}`)){
          sCompleteLook += `<quick-add-modal id="QuickAdd-${selectedIdVariant}" class="quick-add-modal complete-look">
            <div
              role="dialog"
              aria-label="Choose options"
              aria-modal="true"
              class="quick-add-modal__content global-settings-popup"
              tabindex="-1"
            >
              <button
                id="ModalClose-${selectedIdVariant}"
                type="button"
                class="quick-add-modal__toggle"
                aria-label=""
              >
              <svg fill="#000" xmlns="http://www.w3.org/2000/svg" width="20" heigth="16" viewBox="0 0 16 20">
<path d="M13.4 1.45c0-.4.125-.725.375-.975S14.35.1 14.75.1c.375 0 .687.125.937.375s.375.575.375.975c0 .375-.125.688-.375.938s-.562.375-.937.375c-.4 0-.725-.125-.975-.375a1.272 1.272 0 0 1-.375-.938Zm-10.313 0c0 .375-.125.688-.375.938s-.562.375-.937.375-.7-.125-.975-.375a1.272 1.272 0 0 1-.375-.938c0-.4.125-.725.375-.975.275-.25.6-.375.975-.375s.687.125.937.375.375.575.375.975Zm8.063 3.825c0-.375.125-.688.375-.938.275-.25.6-.374.975-.374s.687.125.937.375c.275.25.413.562.413.937s-.138.7-.413.975c-.25.25-.562.375-.937.375s-.7-.125-.975-.375c-.25-.275-.375-.6-.375-.975Zm-5.813 0c0 .375-.125.7-.375.975-.25.25-.575.375-.975.375-.375 0-.687-.125-.937-.375-.25-.275-.375-.6-.375-.975s.125-.688.375-.938.562-.374.937-.374c.4 0 .725.125.975.375s.375.562.375.937ZM7.55 9.1c0 .35-.125.675-.375.975-.25.275-.563.413-.938.413s-.7-.138-.975-.413c-.25-.3-.375-.625-.375-.975 0-.325.125-.625.375-.9.275-.275.6-.412.975-.412s.688.137.938.412c.25.275.375.575.375.9Zm1.387 0c0-.325.125-.625.375-.9s.563-.412.938-.412c.4 0 .725.137.975.412.25.275.375.575.375.9 0 .35-.125.675-.375.975-.25.275-.575.413-.975.413-.375 0-.688-.138-.938-.413-.25-.3-.375-.625-.375-.975Zm-3.6 3.938c0 .374-.125.687-.375.937s-.575.375-.975.375c-.375 0-.687-.125-.937-.375a1.272 1.272 0 0 1-.375-.938c0-.375.125-.687.375-.937.25-.275.562-.412.937-.412.4 0 .725.137.975.412.25.25.375.563.375.938Zm5.813 0c0-.376.125-.688.375-.938.275-.275.6-.412.975-.412s.687.137.937.412c.275.25.413.563.413.938 0 .374-.138.687-.413.937-.25.25-.562.375-.937.375s-.7-.125-.975-.375a1.272 1.272 0 0 1-.375-.938ZM3.087 16.9c0 .4-.125.725-.375.975s-.562.375-.937.375-.7-.125-.975-.375c-.25-.25-.375-.575-.375-.975 0-.375.125-.688.375-.937.275-.25.6-.375.975-.375s.687.125.937.375.375.562.375.937Zm10.313 0c0-.375.125-.688.375-.937.25-.25.575-.375.975-.375.375 0 .687.125.937.375s.375.562.375.937c0 .4-.125.725-.375.975s-.562.375-.937.375c-.4 0-.725-.125-.975-.375S13.4 17.3 13.4 16.9Z" fill="#000"></path>              
</svg>
              </button>
              <div id="QuickAddInfo-${selectedIdVariant}" class="quick-add-modal__content-info"></div>
            </div>
          </quick-add-modal>`;
        }
          
          completeLookGallery.innerHTML = sCompleteLook;      
          // Attach event listeners for "Quick Add" buttons
          this.attachCompleteLookEventHandlers();
      }
      
      // Actualización en la función para manejar eventos
      attachCompleteLookEventHandlers() {
          let self = this;
          // Manejo de botones "Select a size"
          document.querySelectorAll('.size-selector-button').forEach((button) => {
              button.addEventListener('click', () => {
                  button.setAttribute('aria-disabled', true);
                  button.classList.add('loading'); // Agregar clase de carga
                  button.querySelector('.loading-spinner').classList.remove('hidden'); // Mostrar spinner
                  const variantId = button.getAttribute('data-product-variantId');
                  const quickAddModal = document.querySelector(`quick-add-modal#QuickAdd-${variantId}`);
                  if (quickAddModal) {
                      openPopup();
                      quickAddModal.show(button).finally(() => {
                          button.removeAttribute('aria-disabled');
                          button.classList.remove('loading'); // Quitar clase de carga
                          button.querySelector('.loading-spinner').classList.add('hidden'); // Ocultar spinner
                          self.updateGallery();

                          const productTitle = document.querySelector('quick-add-modal[open]')?.querySelector('.product-title h1')?.textContent?.trim().toLowerCase().replace(/\s+/g, '');
                          if (productTitle === "tshirt") {
                            document.querySelector('quick-add-modal[open]').querySelector("#Size-Pop")?.classList.add("hidden");
                          }
                      });
                  } else {
                      console.error('QuickAddModal not found');
                      button.removeAttribute('aria-disabled');
                      button.classList.remove('loading');
                      button.querySelector('.loading-spinner').classList.add('hidden');
                  }
              });
          });

        

      
          document.addEventListener("DOMContentLoaded", function () {
              // Delegación de eventos: escucha el evento en un contenedor común (por ejemplo, body o un contenedor específico)
              document.body.addEventListener('click', function (e) {
                  self.redirigeProducto(e);
              });
          });
      }


      redirigeProducto(event) {
        // Asegúrate de que el clic viene de un elemento con la clase .product__view-details
        if (event.target.matches('.product__view-details')) {
          const productUrl = event.target.getAttribute('data-product');
          let variantSelected; //= document.querySelector('quick-add-modal .swatch-input__input[checked]').getAttribute('data-option-value');

          const labels = document.querySelectorAll('quick-add-modal .swatch-input__label');

          // Itera sobre ellos para verificar cuál está seleccionado
          labels.forEach(label => {
            // Busca el input asociado usando el atributo for o un contenedor cercano
            const input = document.querySelector(`#${label.getAttribute('for')}`) || label.querySelector('input');
          
            if (input && input.checked) {
              variantSelected = input.getAttribute('data-option-value')
            }
          });
          

          const result = this.productsInfo.find(item => 
            item.productUrl.includes(productUrl) && item.color === variantSelected.toUpperCase()
          );

          //console.log(result?.product);
          // Redirigir a la nueva URL
          window.location.href = result?.productUrl;
        }
      }
      
      getSelectedColor() {
        return document.querySelector('quick-add-modal[open]') ? 
          document.querySelector('quick-add-modal[open] .custom_color_form__label span')?.textContent?.toLowerCase() :
          document.querySelector('.custom_color_form__label span')?.textContent?.toLowerCase();
        
      }


      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        const esCambioColor = target.name.indexOf('Color') > -1; //revisa si es cambio de color
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        const quickAddModalOpen = document.querySelector('quick-add-modal[open]');
        const selectedColor = this.getSelectedColor();

        // Llamar a la función para actualizar la galería con la variante seleccionada
        if(esCambioColor) this.updateGallery();
        
        
        //console.log(selectedColor, this.colorAnterior);
        // Handle color changes
        if (selectedColor !== this.colorAnterior) { //si cambia color y no esta abierto el modal
          console.log(selectedColor, 'cambia');
          this.colorAnterior = selectedColor;

          if (window.innerWidth <= 768){ // only mobile
            const elementSliders = [...document.getElementsByClassName('product__media-list contains-media')];
            // scroll to left, so only mobile
            elementSliders.forEach((elementItem)=>{            
              elementItem.scrollTo({ left: 0, behavior: "smooth" });
              elementItem.scrollLeft = 0; // Move to the leftmost position
              requestAnimationFrame(() => {
                  elementItem.scrollLeft = 0; // Ensure Safari handles it
              });
              // hide slider for mobile while changes are done
              elementItem.style.visibility = "hidden";
              setTimeout(() => {
                  elementItem.style.visibility = "visible";
              }, 800);
            });
          }
          if(!quickAddModalOpen){
            this.updateRecommendation();
            this.updateCompleteLook();  
          }
        }

  
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl, quickAddModalOpen),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          // Se comenta para que se puedan seleccionar cambio de colores aunque no tenga disponibilidad de inventario
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
       }
      }


      handleUpdateProductInfo(productUrl, esModal) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }
          // solo si no es modal se procesa el cambio de media
          if(!esModal) this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          console.log(this.productForm);

          /*this.productForm?.toggleSubmitButton(
            (html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') && document.getElementsByClassName('coming-soon-message').length > 0)
            ?? true,
            window.variantStrings.soldOut
          );*/

          const container = esModal
            ? document.querySelector('quick-add-modal[open]')
            : this;
          
          // Intenta buscar por ID y, si no existe, por clase
          let submitButton = container?.querySelector(`#ProductSubmitButton-${this.sectionId}`) ||
                             container?.querySelector('button.product-form__submit');
          
          let submitButtonLabel = submitButton?.querySelector('span');
          
          if (submitButton) {
            if (!variant.available) {
              submitButton.disabled = true;
              submitButton.setAttribute('aria-disabled', 'true');
              if (submitButtonLabel) submitButtonLabel.textContent = window.variantStrings?.soldOut || 'Sold Out';
              else submitButton.textContent = window.variantStrings?.soldOut || 'Sold Out';
            } else {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-disabled');
              if (submitButtonLabel) submitButtonLabel.textContent = window.variantStrings?.addToCart || 'Add to Bag';
              else submitButton.textContent = window.variantStrings?.addToCart || 'Add to Bag';
            }
          }


          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        /*this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );*/

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}


function openPopup() {
     // Save the current scroll position in a data attribute
    const scrollPosition = window.scrollY;

    // Set styles directly on the body
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    // Store the scroll position inside the body's style attribute
    document.body.setAttribute('data-scroll', scrollPosition);

}

